import React, { useState } from 'react';
import { X, Clock, Check, X as XIcon } from 'lucide-react';
import SimpleTimePicker from './SimpleTimePicker';

const AddTimeModal = ({ isOpen, onClose, onConfirm }) => {
  const [timeInput, setTimeInput] = useState('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (timeInput.trim()) {
      onConfirm(timeInput.trim());
      setTimeInput('');
      onClose();
    }
  };

  const handleCancel = () => {
    setTimeInput('');
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleConfirm();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content max-w-md relative" onClick={(e) => e.stopPropagation()}>
        {/* 关闭按钮 */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 p-2 rounded-full hover:bg-gray-100 z-10 flex items-center justify-center"
        >
          <X size={18} />
        </button>

        <div className="modal-header">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center">
            <Clock size={20} className="mr-2" />
            添加时间
          </h3>
        </div>

        <div className="modal-body">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              时间格式
            </label>
            <SimpleTimePicker
              value={timeInput}
              onChange={setTimeInput}
              placeholder="选择时间"
              className="w-full"
            />
            <p className="text-xs text-gray-500 mt-1">
              选择时间，系统会自动生成时间范围
            </p>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={handleConfirm}>
            <Check size={16} className="mr-2" />
            确认
          </button>
          <button className="btn btn-danger" onClick={handleCancel}>
            <XIcon size={16} className="mr-2" />
            取消
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTimeModal;
